import * as React from "react";
import {none, option, Option} from "ts-option";
import Modal from "../../../../ui/modal/Modal";
import SelectMerchant from "./SelectMerchant";
import {ImportResult} from "../../../../../model/importResult/ImportResult";
import Toast from "../../../../helper/Toast";
import {api} from "../../../../../api/api";
import SingleFileSelector from "../../../../file/SingleFileSelector";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";
import Merchant from "../../../../../model/merchant/Merchant";

interface Props {
	/**
	 * On close modal callback.
	 */
	onClose: () => void;
	/**
	 * Placeholder.
	 */
	placeholder: string;
}

interface IState {
	/**
	 * Indicates if file is being uploaded
	 */
	isUploading: boolean;
	/**
	 * Selected merchant
	 */
	merchant: Option<Merchant>;
	/**
	 * Upload errors to display
	 */
	errors: string[];
}

export default class UploadAssetMaterialsModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isUploading: false, merchant: none, errors: []};
		this.uploadFile = this.uploadFile.bind(this);
	}

	render() {
		return (
			<Modal customClass={"c-upload-asset-materials-modal"}
				   onCloseClicked={this.props.onClose}
				   title={"Upload asset materials"}
				   autoWidth={true}>
				<label>Merchant</label>
				<SelectMerchant placeholder={this.props.placeholder}
								selectedId={this.state.merchant.map(m => m.id)}
								onChanged={this.onChange}/>
				<label>File</label>
				<SingleFileSelector onUpload={this.uploadFile}
									onCancel={this.props.onClose}
									errors={option(this.state.errors)}
									filesUploading={this.state.isUploading}
									isUploadButtonDisabled={this.state.merchant.isEmpty}/>
			</Modal>
		);
	}

	/**
	 * Callback on merchant changed.
	 * @param selectedMerchant
	 */
	onChange = (selectedMerchant: Option<Merchant>) => {
		this.setState({merchant: selectedMerchant})
	};

	/**
	 * Upload file
	 */
	uploadFile(file: File) {
		if (file && this.state.merchant.isDefined) {
			this.setState({isUploading: true}, () => {
				api.instance.merchantApi.uploadAssetMaterials(this.state.merchant.map(m => m.id).get, file).then(() => {
					Toast.success("Asset materials uploaded successfully.", "Asset materials upload");
					this.setState({isUploading: false});
					this.props.onClose();
				}).catch((error: any) => {
					this.setState({isUploading: false});
					if (error && error.response && error.response.status == 400) {
						const errors = ImportResult.fromJson(error.response.data);
						this.setState({errors: errors.error});
						Toast.error("Cannot upload asset materials.", "Asset materials upload");
					}
					else {
						notifyBugsnagAndShowToast(error, "Asset materials upload");
					}
				});
			});
		}
	}
}